import { render } from "./MES.vue?vue&type=template&id=4d916636"
import script from "./MES.vue?vue&type=script&lang=js"
export * from "./MES.vue?vue&type=script&lang=js"
script.render = render

export default script